import { Typography, ListItem, useTheme, Box } from "@mui/material";
import { Link } from "react-router-dom";

interface ContributorCardProps {
  item: {
    name: string;
    affiliate_title: string;
    country_code: string;
    profile_img_url?: string;
    personal_website?: string | null;
    affiliate?: string;
  };
}

export default function ContributorCard({ item }: ContributorCardProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        maxWidth: "100%",
        width: '100%',
      }}>
      <Typography sx={{
        fontSize: { lg: "24px", md: "22px", xs: "20px" },
        fontWeight: '600',
        color: theme.customColors.primary.prusianBlue,
        lineHeight: '1.4'
      }} variant="h4">
        {item.personal_website ? (
          <Link
            to={item.personal_website.includes('\/\/') ? item.personal_website : `\/\/${item.personal_website}`}
            target="_blank"
            style={{ color: theme.customColors.primary.prusianBlue }}
          >
            {item.name} ({item.country_code})
          </Link>
        ) : (
          <>
            {item.name} ({item.country_code})
          </>
        )}
      </Typography>
      {/* <Typography variant="h4" style={{ margin: 0, fontWeight: 500 }}>
        {item.affiliate_title}
      </Typography> */}
      <Typography sx={{
        fontSize: { lg: "22px", md: "20px", xs: "18px" }, fontWeight: '500',
        color: theme.customColors.primary.prusianBlue, fontStyle: 'italic'
      }}
      >
        {item.affiliate}
      </Typography>
    </Box>
  );
}
